// source: proto/entity/siteGrouping.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_dimensionGrouping_pb = require('../../proto/common/dimensionGrouping_pb.js');
goog.object.extend(proto, proto_common_dimensionGrouping_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_common_value_pb = require('../../proto/common/value_pb.js');
goog.object.extend(proto, proto_common_value_pb);
var proto_entity_site_pb = require('../../proto/entity/site_pb.js');
goog.object.extend(proto, proto_entity_site_pb);
goog.exportSymbol('proto.entity.GroupingData', null, global);
goog.exportSymbol('proto.entity.GroupingDefinition', null, global);
goog.exportSymbol('proto.entity.GroupingDimensionDefinition', null, global);
goog.exportSymbol('proto.entity.GroupingVersion', null, global);
goog.exportSymbol('proto.entity.NewSiteGrouping', null, global);
goog.exportSymbol('proto.entity.SiteGrouping', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewSiteGrouping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.NewSiteGrouping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewSiteGrouping.displayName = 'proto.entity.NewSiteGrouping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SiteGrouping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.SiteGrouping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SiteGrouping.displayName = 'proto.entity.SiteGrouping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GroupingDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.GroupingDefinition.repeatedFields_, null);
};
goog.inherits(proto.entity.GroupingDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GroupingDefinition.displayName = 'proto.entity.GroupingDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GroupingData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GroupingData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GroupingData.displayName = 'proto.entity.GroupingData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GroupingVersion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GroupingVersion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GroupingVersion.displayName = 'proto.entity.GroupingVersion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GroupingDimensionDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GroupingDimensionDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GroupingDimensionDefinition.displayName = 'proto.entity.GroupingDimensionDefinition';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewSiteGrouping.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewSiteGrouping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewSiteGrouping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewSiteGrouping.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    siteGroupingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    definition: (f = msg.getDefinition()) && proto.entity.GroupingDefinition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewSiteGrouping}
 */
proto.entity.NewSiteGrouping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewSiteGrouping;
  return proto.entity.NewSiteGrouping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewSiteGrouping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewSiteGrouping}
 */
proto.entity.NewSiteGrouping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteGroupingId(value);
      break;
    case 3:
      var value = new proto.entity.GroupingDefinition;
      reader.readMessage(value,proto.entity.GroupingDefinition.deserializeBinaryFromReader);
      msg.setDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewSiteGrouping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewSiteGrouping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewSiteGrouping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewSiteGrouping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSiteGroupingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDefinition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.GroupingDefinition.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.NewSiteGrouping.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.NewSiteGrouping} returns this
*/
proto.entity.NewSiteGrouping.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewSiteGrouping} returns this
 */
proto.entity.NewSiteGrouping.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewSiteGrouping.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string site_grouping_id = 2;
 * @return {string}
 */
proto.entity.NewSiteGrouping.prototype.getSiteGroupingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.NewSiteGrouping} returns this
 */
proto.entity.NewSiteGrouping.prototype.setSiteGroupingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional GroupingDefinition definition = 3;
 * @return {?proto.entity.GroupingDefinition}
 */
proto.entity.NewSiteGrouping.prototype.getDefinition = function() {
  return /** @type{?proto.entity.GroupingDefinition} */ (
    jspb.Message.getWrapperField(this, proto.entity.GroupingDefinition, 3));
};


/**
 * @param {?proto.entity.GroupingDefinition|undefined} value
 * @return {!proto.entity.NewSiteGrouping} returns this
*/
proto.entity.NewSiteGrouping.prototype.setDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewSiteGrouping} returns this
 */
proto.entity.NewSiteGrouping.prototype.clearDefinition = function() {
  return this.setDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewSiteGrouping.prototype.hasDefinition = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SiteGrouping.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SiteGrouping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SiteGrouping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SiteGrouping.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    siteGroupingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupingVersion: (f = msg.getGroupingVersion()) && proto.entity.GroupingVersion.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SiteGrouping}
 */
proto.entity.SiteGrouping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SiteGrouping;
  return proto.entity.SiteGrouping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SiteGrouping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SiteGrouping}
 */
proto.entity.SiteGrouping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteGroupingId(value);
      break;
    case 3:
      var value = new proto.entity.GroupingVersion;
      reader.readMessage(value,proto.entity.GroupingVersion.deserializeBinaryFromReader);
      msg.setGroupingVersion(value);
      break;
    case 4:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SiteGrouping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SiteGrouping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SiteGrouping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SiteGrouping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getSiteGroupingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupingVersion();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.GroupingVersion.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.SiteGrouping.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.SiteGrouping} returns this
*/
proto.entity.SiteGrouping.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SiteGrouping} returns this
 */
proto.entity.SiteGrouping.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SiteGrouping.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string site_grouping_id = 2;
 * @return {string}
 */
proto.entity.SiteGrouping.prototype.getSiteGroupingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SiteGrouping} returns this
 */
proto.entity.SiteGrouping.prototype.setSiteGroupingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional GroupingVersion grouping_version = 3;
 * @return {?proto.entity.GroupingVersion}
 */
proto.entity.SiteGrouping.prototype.getGroupingVersion = function() {
  return /** @type{?proto.entity.GroupingVersion} */ (
    jspb.Message.getWrapperField(this, proto.entity.GroupingVersion, 3));
};


/**
 * @param {?proto.entity.GroupingVersion|undefined} value
 * @return {!proto.entity.SiteGrouping} returns this
*/
proto.entity.SiteGrouping.prototype.setGroupingVersion = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SiteGrouping} returns this
 */
proto.entity.SiteGrouping.prototype.clearGroupingVersion = function() {
  return this.setGroupingVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SiteGrouping.prototype.hasGroupingVersion = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.CRUDFields crud_fields = 4;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.SiteGrouping.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 4));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.SiteGrouping} returns this
*/
proto.entity.SiteGrouping.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SiteGrouping} returns this
 */
proto.entity.SiteGrouping.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SiteGrouping.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.GroupingDefinition.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GroupingDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GroupingDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GroupingDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dimensionSelectorsList: jspb.Message.toObjectList(msg.getDimensionSelectorsList(),
    proto_common_dimensionGrouping_pb.DimensionGrouping.Selector.toObject, includeInstance),
    dimensionDefinition: (f = msg.getDimensionDefinition()) && proto.entity.GroupingDimensionDefinition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GroupingDefinition}
 */
proto.entity.GroupingDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GroupingDefinition;
  return proto.entity.GroupingDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GroupingDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GroupingDefinition}
 */
proto.entity.GroupingDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto_common_dimensionGrouping_pb.DimensionGrouping.Selector;
      reader.readMessage(value,proto_common_dimensionGrouping_pb.DimensionGrouping.Selector.deserializeBinaryFromReader);
      msg.addDimensionSelectors(value);
      break;
    case 3:
      var value = new proto.entity.GroupingDimensionDefinition;
      reader.readMessage(value,proto.entity.GroupingDimensionDefinition.deserializeBinaryFromReader);
      msg.setDimensionDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GroupingDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GroupingDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GroupingDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDimensionSelectorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_dimensionGrouping_pb.DimensionGrouping.Selector.serializeBinaryToWriter
    );
  }
  f = message.getDimensionDefinition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.GroupingDimensionDefinition.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.entity.GroupingDefinition.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GroupingDefinition} returns this
 */
proto.entity.GroupingDefinition.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated common.DimensionGrouping.Selector dimension_selectors = 2;
 * @return {!Array<!proto.common.DimensionGrouping.Selector>}
 */
proto.entity.GroupingDefinition.prototype.getDimensionSelectorsList = function() {
  return /** @type{!Array<!proto.common.DimensionGrouping.Selector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_dimensionGrouping_pb.DimensionGrouping.Selector, 2));
};


/**
 * @param {!Array<!proto.common.DimensionGrouping.Selector>} value
 * @return {!proto.entity.GroupingDefinition} returns this
*/
proto.entity.GroupingDefinition.prototype.setDimensionSelectorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.DimensionGrouping.Selector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DimensionGrouping.Selector}
 */
proto.entity.GroupingDefinition.prototype.addDimensionSelectors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.DimensionGrouping.Selector, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.GroupingDefinition} returns this
 */
proto.entity.GroupingDefinition.prototype.clearDimensionSelectorsList = function() {
  return this.setDimensionSelectorsList([]);
};


/**
 * optional GroupingDimensionDefinition dimension_definition = 3;
 * @return {?proto.entity.GroupingDimensionDefinition}
 */
proto.entity.GroupingDefinition.prototype.getDimensionDefinition = function() {
  return /** @type{?proto.entity.GroupingDimensionDefinition} */ (
    jspb.Message.getWrapperField(this, proto.entity.GroupingDimensionDefinition, 3));
};


/**
 * @param {?proto.entity.GroupingDimensionDefinition|undefined} value
 * @return {!proto.entity.GroupingDefinition} returns this
*/
proto.entity.GroupingDefinition.prototype.setDimensionDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GroupingDefinition} returns this
 */
proto.entity.GroupingDefinition.prototype.clearDimensionDefinition = function() {
  return this.setDimensionDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GroupingDefinition.prototype.hasDimensionDefinition = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GroupingData.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GroupingData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GroupingData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingData.toObject = function(includeInstance, msg) {
  var f, obj = {
    current: (f = msg.getCurrent()) && proto.entity.GroupingVersion.toObject(includeInstance, f),
    versionsMap: (f = msg.getVersionsMap()) ? f.toObject(includeInstance, proto.entity.GroupingVersion.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GroupingData}
 */
proto.entity.GroupingData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GroupingData;
  return proto.entity.GroupingData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GroupingData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GroupingData}
 */
proto.entity.GroupingData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.GroupingVersion;
      reader.readMessage(value,proto.entity.GroupingVersion.deserializeBinaryFromReader);
      msg.setCurrent(value);
      break;
    case 2:
      var value = msg.getVersionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.entity.GroupingVersion.deserializeBinaryFromReader, 0, new proto.entity.GroupingVersion());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GroupingData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GroupingData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GroupingData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.GroupingVersion.serializeBinaryToWriter
    );
  }
  f = message.getVersionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.entity.GroupingVersion.serializeBinaryToWriter);
  }
};


/**
 * optional GroupingVersion current = 1;
 * @return {?proto.entity.GroupingVersion}
 */
proto.entity.GroupingData.prototype.getCurrent = function() {
  return /** @type{?proto.entity.GroupingVersion} */ (
    jspb.Message.getWrapperField(this, proto.entity.GroupingVersion, 1));
};


/**
 * @param {?proto.entity.GroupingVersion|undefined} value
 * @return {!proto.entity.GroupingData} returns this
*/
proto.entity.GroupingData.prototype.setCurrent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GroupingData} returns this
 */
proto.entity.GroupingData.prototype.clearCurrent = function() {
  return this.setCurrent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GroupingData.prototype.hasCurrent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int32, GroupingVersion> versions = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.entity.GroupingVersion>}
 */
proto.entity.GroupingData.prototype.getVersionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.entity.GroupingVersion>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.entity.GroupingVersion));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.GroupingData} returns this
 */
proto.entity.GroupingData.prototype.clearVersionsMap = function() {
  this.getVersionsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GroupingVersion.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GroupingVersion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GroupingVersion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingVersion.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, 0),
    definition: (f = msg.getDefinition()) && proto.entity.GroupingDefinition.toObject(includeInstance, f),
    createdTime: (f = msg.getCreatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GroupingVersion}
 */
proto.entity.GroupingVersion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GroupingVersion;
  return proto.entity.GroupingVersion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GroupingVersion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GroupingVersion}
 */
proto.entity.GroupingVersion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 2:
      var value = new proto.entity.GroupingDefinition;
      reader.readMessage(value,proto.entity.GroupingDefinition.deserializeBinaryFromReader);
      msg.setDefinition(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GroupingVersion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GroupingVersion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GroupingVersion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingVersion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDefinition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.GroupingDefinition.serializeBinaryToWriter
    );
  }
  f = message.getCreatedTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 version = 1;
 * @return {number}
 */
proto.entity.GroupingVersion.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.GroupingVersion} returns this
 */
proto.entity.GroupingVersion.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional GroupingDefinition definition = 2;
 * @return {?proto.entity.GroupingDefinition}
 */
proto.entity.GroupingVersion.prototype.getDefinition = function() {
  return /** @type{?proto.entity.GroupingDefinition} */ (
    jspb.Message.getWrapperField(this, proto.entity.GroupingDefinition, 2));
};


/**
 * @param {?proto.entity.GroupingDefinition|undefined} value
 * @return {!proto.entity.GroupingVersion} returns this
*/
proto.entity.GroupingVersion.prototype.setDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GroupingVersion} returns this
 */
proto.entity.GroupingVersion.prototype.clearDefinition = function() {
  return this.setDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GroupingVersion.prototype.hasDefinition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp created_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.GroupingVersion.prototype.getCreatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.GroupingVersion} returns this
*/
proto.entity.GroupingVersion.prototype.setCreatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GroupingVersion} returns this
 */
proto.entity.GroupingVersion.prototype.clearCreatedTime = function() {
  return this.setCreatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GroupingVersion.prototype.hasCreatedTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GroupingDimensionDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GroupingDimensionDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GroupingDimensionDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingDimensionDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valueType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GroupingDimensionDefinition}
 */
proto.entity.GroupingDimensionDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GroupingDimensionDefinition;
  return proto.entity.GroupingDimensionDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GroupingDimensionDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GroupingDimensionDefinition}
 */
proto.entity.GroupingDimensionDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommonName(value);
      break;
    case 2:
      var value = /** @type {!proto.common.ValueType.Option} */ (reader.readEnum());
      msg.setValueType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GroupingDimensionDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GroupingDimensionDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GroupingDimensionDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GroupingDimensionDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValueType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string common_name = 1;
 * @return {string}
 */
proto.entity.GroupingDimensionDefinition.prototype.getCommonName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GroupingDimensionDefinition} returns this
 */
proto.entity.GroupingDimensionDefinition.prototype.setCommonName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.ValueType.Option value_type = 2;
 * @return {!proto.common.ValueType.Option}
 */
proto.entity.GroupingDimensionDefinition.prototype.getValueType = function() {
  return /** @type {!proto.common.ValueType.Option} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.ValueType.Option} value
 * @return {!proto.entity.GroupingDimensionDefinition} returns this
 */
proto.entity.GroupingDimensionDefinition.prototype.setValueType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.entity);
